import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { textCodes, titleCodes, videoCodes } from '../../template_codes/encore/about_page_codes';

export default function AboutPage() {
    return (
        <div className="pt-0">
            {/** 
            <iframe width="560" height="315" src="https://www.youtube.com/embed/2Wo-snB62Q0?autoplay=1 " title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loop autoplay className='absolute w-full h-full object-cover'>
            </iframe>
            <div className='overlay absolute w-full h-full bg-overlay blend-screen'></div>
*/}
            <div className='container w-4/5 text-center pb-10 z-40 relative'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold pt-20'>{titleCodes.aboutTitle.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.about.text}</p>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.about1.text}</p>
            </div>

            {/**
            <div>
                <video poster="https://rollpark.us/wp-content/uploads/2018/10/hero-image.jpg" data-autoplay="" class="video-short" autoplay="" muted="" playsinline="" loop=""
                    src={videoCodes.video1.video} type="video/mp4">
                </video>
            </div>
             */}

            <div className="container w-full md:w-5/6 lg:w-5/6 xl:w-5/6 2xl:w-5/6 pt-12">
                <embed
                    src={videoCodes.video1.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loop autoplay
                    className='w-full h-screen data-autoplay= video-short"'>
                </embed>
            </div>
        </div>


    )
}
